<template>
  <div class="home-container">
    <DeveloperArea class="home-section home-section--delay-0" />
    <HelloDev class="home-section home-section--delay-1" />
    <BenefitsSection class="home-section home-section--delay-2" />
    <FinalSection class="home-section home-section--delay-3" />
  </div>
</template>

<script setup>
import { defineAsyncComponent, onMounted, onUnmounted } from 'vue';
import DeveloperArea from './DeveloperArea.vue'
import { isDarkTheme } from '@/services/theme-state.js';

const HelloDev = defineAsyncComponent(() => import('./HelloDev.vue'));
const BenefitsSection = defineAsyncComponent(() => import('./BenefitsSection.vue'));
const FinalSection = defineAsyncComponent(() => import('./FinalSection.vue'));

onMounted(() => {
  document.body.classList.add('dark-theme');
  isDarkTheme.value = true;
})

onUnmounted(() => {
  document.body.classList.remove('dark-theme');
  isDarkTheme.value = false;
})

</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
  margin-top: -84px;
}

.home-section {
  animation: fadeSlideUp 0.6s ease both;
}

.home-section--delay-0 { animation-delay: 0s; }
.home-section--delay-1 { animation-delay: 0.15s; }
.home-section--delay-2 { animation-delay: 0.3s; }
.home-section--delay-3 { animation-delay: 0.45s; }

@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>